export default "__VITE_ASSET__BbK7H6ST__"